import { useSelector } from "react-redux";

import { getLivestockSaleId } from "lib/navigation";
import { getBestMatchingSplit } from "lib/splits";

import {
  selectBuyerSplitByKeyLookup,
  selectVendorSplitByKeyLookup,
} from "selectors";

interface Props {
  primaryBusinessId: string | null | undefined;
  deploymentId: number | null | undefined;
  consignmentId?: string;
  saleLotId?: string;
}

export const useGetBestMatchingVendorSplit = ({
  primaryBusinessId = null,
  deploymentId = null,
  consignmentId,
  saleLotId,
}: Props): VendorSplit | undefined => {
  const splitByKeyLookup = useSelector(selectVendorSplitByKeyLookup);
  const livestockSaleId = getLivestockSaleId();
  if (!primaryBusinessId || !deploymentId) {
    return undefined;
  }
  return getBestMatchingSplit({
    splitByKeyLookup,
    primaryBusinessId,
    deploymentId,
    livestockSaleId,
    consignmentId,
    saleLotId,
  }) as VendorSplit;
};

export const useGetBestMatchingBuyerSplit = ({
  primaryBusinessId = null,
  deploymentId = null,
  consignmentId,
  saleLotId,
}: Props): BuyerSplit | undefined => {
  const splitByKeyLookup = useSelector(selectBuyerSplitByKeyLookup);
  const livestockSaleId = getLivestockSaleId();
  if (!primaryBusinessId || !deploymentId) {
    return undefined;
  }
  return getBestMatchingSplit({
    splitByKeyLookup,
    primaryBusinessId,
    deploymentId,
    livestockSaleId,
    consignmentId,
    saleLotId,
  }) as BuyerSplit;
};
